import React from 'react';

const Home: React.FC = () => {
   
    return (
        <>
           
          
        </>
    );
}

export default Home;
